import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["banner"]

  connect() {
    if (this.hasConsent() || this.laterDismissed()) {
      this.element.remove()
    } else {
      this.show()
    }
  }

  accept() {
    this.setCookie()
    this.dismiss()
  }

  later() {
    sessionStorage.setItem("cookie_consent_later", "1")
    this.dismiss()
  }

  show() {
    this.bannerTarget.classList.remove("translate-y-full", "opacity-0", "pointer-events-none")
    this.bannerTarget.classList.add("translate-y-0", "opacity-100")
  }

  hide() {
    this.bannerTarget.classList.remove("translate-y-0", "opacity-100")
    this.bannerTarget.classList.add("translate-y-full", "opacity-0", "pointer-events-none")
  }

  dismiss() {
    this.hide()
    setTimeout(() => this.element.remove(), 300)
  }

  hasConsent() {
    return document.cookie.split("; ").some((row) => row.startsWith("cookie_consent=accepted"))
  }

  laterDismissed() {
    return sessionStorage.getItem("cookie_consent_later") === "1"
  }

  setCookie() {
    const secure = window.location.protocol === "https:" ? "; Secure" : ""
    document.cookie = `cookie_consent=accepted; max-age=31536000; path=/; SameSite=Lax${secure}`
  }
}
